import FilterCard from "../FilterCard/FilterCard";
import {Button, Select} from "antd";
import useApi from "../../../../../../hooks/useApi";
import {API_getDrivers} from "../../../../../../services/api/apiCalls";
import {useEffect, useState} from "react";
import {mdiCar} from "@mdi/js";
const DriverFilter = ({onChange}) => {
    const [options,setOptions] = useState([]);
    const handleChange = (value, option) => {
        onChange({driverId: value})
    }
    const getDriversApi = useApi(API_getDrivers,[], "Nie udało się pobrać kierowców.",true,true)
    useEffect(() => {
        getDriversApi.call();
    }, [])
    useEffect(() => {
        let tmpArr = [];
        if(!Array.isArray( getDriversApi?.data)) return;
        getDriversApi.data.forEach(driver => {
            tmpArr.push({
                value: driver.id,
                label: driver.name + " " + driver.lastname
            })
        })
        setOptions(tmpArr)
    },[JSON.stringify(getDriversApi.data)])
    const filterOption = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
    return (
        <FilterCard title="Kierowca" iconPath={mdiCar}>
            <Select
                style={{width:200}}
                allowClear
                showSearch
                placeholder="Wybierz kierowcę"
                optionFilterProp="children"
                onChange={handleChange}
                onSearch={() => {}}
                filterOption={filterOption}
                loading={getDriversApi.loading}
                options={options}
            />
        </FilterCard>
    )
}
export default DriverFilter